// extracted by mini-css-extract-plugin
export default {"file-name":"bulk_file-name__+FOmc"};